import type { MaybeRefOrGetter } from 'vue';
import { toValue } from 'vue';

import { t } from '../../../locale';
import type { ValidationMessage, ValidationRule } from '../useValidation.types';
import isDefined from '../utils/isDefined';

interface Config {
  min: MaybeRefOrGetter<number>;
  message?: ValidationMessage;
}

export default function minValue(config: Config): ValidationRule {
  return {
    name: 'minValue',
    validator(value) {
      const min = toValue(config.min);

      return !isDefined(value) || Number(value) >= min;
    },
    message: config.message || (() => t('ll.validation.minValue', { min: String(toValue(config.min)) })),
  };
}
